<template>
    <div>
        <span style="font-size: 2rem; font-weight: 500;">{{step_data.step_name}}</span>
        <div>
                <div v-if="step_data.spreadify_views.length > 0">
                    <form-plugin @formDataUpdated="updateFormData" :viewData="step_data.spreadify_views[0].form_data" :uid="step_data.spreadify_views[0].spreadify_uid"></form-plugin>
                    <b-button @click="save" variant="success">
                        Save
                    </b-button>
                </div>
        </div>
    </div>
</template>

<script>
import { licenseAppState, licenseAppMethods } from '@/state/helpers'
export default {
    data:() => ({
        current_form_data: {},
        params:{},
    }),
    computed:{
        ...licenseAppState,
    },
    methods:{
        ...licenseAppMethods,
        updateFormData(newData){
            //*event fired from <form-plugin>
            this.current_form_data = newData.data;
        },
        save(){
            let data = {
                spreadify_uid: this.step_data.spreadify_views[0].spreadify_uid,
                form_data: [],
            }
            for(const key in this.current_form_data){
                data.form_data.push({key: key, value: this.current_form_data[key]})
            }
            this.params.form_data[0] = data;


            this.saveFormData(this.params)
            .then(()=>{
                this.$swal.fire({ toast: true, position: 'top', iconColor: 'white', icon: 'success', title:'Saved Form', customClass: {     popup: 'success-toast' }, showConfirmButton: false, timer: 2000, timerProgressBar: true});
                this.requestStepApproval(this.step_data.id)
                .then(()=>{
                    this.$emit('back', this.step_data.id);
                })
            })
            .catch(()=>{
                this.$swal.fire({ toast: true, position: 'top', iconColor: 'white', icon: 'error', title:'Saved Configuration', customClass: {     popup: 'error-toast' }, showConfirmButton: false, timer: 2000, timerProgressBar: true});
            })
        }
    },
    mounted(){
        this.params = {
            step_id: this.step_data.id,
            form_data:[],
        }
    },
}
</script>

<style>

</style>